import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.166",
  height: "13.396",
  "data-name": "그룹 449"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#dedede",
      d: "m19.166 3.964-1.385 1.385a11.607 11.607 0 0 0-16.4 0L0 3.964a13.57 13.57 0 0 1 19.166 0",
      "data-name": "패스 111"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.259 8.871-1.385 1.385a4.66 4.66 0 0 0-6.581 0L4.908 8.871a6.62 6.62 0 0 1 9.351 0",
      "data-name": "패스 112"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m16.713 6.417-1.385 1.385a8.133 8.133 0 0 0-11.488 0L2.455 6.417a10.094 10.094 0 0 1 14.259 0",
      "data-name": "패스 113"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m7.362 11.175.693.693.693.693.837.837.837-.837.693-.693.693-.693a3.146 3.146 0 0 0-4.443 0",
      "data-name": "패스 114"
    }, null, -1)
  ])))
}
export default { render: render }